import React from 'react';
import { 
  Person as PersonIcon, 
  Business as BusinessIcon, 
  Code as CodeIcon, 
  Analytics as AnalyticsIcon, 
  AttachMoney as FinanceIcon, 
  Insights as InsightsIcon, 
  Lightbulb as GrowthIcon, 
  Psychology as StrategyIcon, 
  Engineering as EngineeringIcon, 
  Menu as MenuIcon, 
  Mic as VoiceIcon, 
  AccountCircle as DefaultIcon 
} from '@mui/icons-material';

// Map of avatar types to components
const avatarComponents: Record<string, React.ReactNode> = {
  person: <PersonIcon />,
  business: <BusinessIcon />,
  code: <CodeIcon />,
  analytics: <AnalyticsIcon />,
  finance: <FinanceIcon />,
  insights: <InsightsIcon />,
  growth: <GrowthIcon />,
  strategy: <StrategyIcon />,
  engineering: <EngineeringIcon />,
  MenuIcon: <MenuIcon />,
  VoiceIcon: <VoiceIcon />,
  default: <DefaultIcon />
};

/**
 * Get avatar component based on type
 * @param type Avatar type
 * @param color Color for the avatar
 * @param size Size of the avatar
 * @returns React component or image path
 */
export const getAvatarComponent = (
  type: string,
  color: string = '#8A2BE2',
  size: number = 20
): React.ReactNode | string => {
  // Check if we have a component for this type
  if (avatarComponents[type.toLowerCase()]) {
    const Component = avatarComponents[type.toLowerCase()];
    return React.cloneElement(Component as React.ReactElement, {
      sx: { color, fontSize: size }
    });
  }
  
  // If not a component, assume it's an image path
  return type;
}; 